import React from 'react'

function ClinicalExamination() {
  return (
    <div>ClinicalExamination</div>
  )
}

export default ClinicalExamination